import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';

//import resources
import Skeleton from 'react-loading-skeleton';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

// //import api
import FetchData from '../api/Api';

export default function About() {

    //get locale
    const { locale } = useParams();
    const { t } = useTranslation();

    //get data
    const [data, setData] = useState(null);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/about`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            fetchData();
        }

    }, [data]);


    useEffect(()=> {
        setData(null);
    }, [locale])

    return (
        <>
            <Breadcrumb title={t('about')} />
            <div className='container mx-auto mt-12 px-3'>
                <div className='grid grid-cols-12 gap-5'>
                    <div className='col-span-12'>
                        <div className='text-[16px] md:text-[18px] lg:text-[25px] upper font-bold mb-5'>{t('about')}</div>
                        <div className='text-[14px] md:text-[15px] lg:text-[16px]'>
                            {data?.data?.translations?.[0]?.html ? (
                                (<div dangerouslySetInnerHTML={{ __html: data.data.translations[0].html }} />)
                            ) : (
                                <Skeleton height={20} count={10} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}